import { render, staticRenderFns } from "./SermsukClickLayout.vue?vue&type=template&id=1eac4468&scoped=true"
import script from "./SermsukClickLayout.vue?vue&type=script&lang=js"
export * from "./SermsukClickLayout.vue?vue&type=script&lang=js"
import style0 from "./SermsukClickLayout.vue?vue&type=style&index=0&id=1eac4468&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eac4468",
  null
  
)

export default component.exports